import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { AfterContentInit, AfterViewChecked, Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { StoreType } from 'src/app/models';
import { IconButtonComponent, TextButtonComponent } from 'src/app/shared/components';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { FilterMenuComponent } from 'src/app/shared/components/filter-menu/filter-menu.component';
import { ProductCardComponent } from 'src/app/shared/components/product/card';
import { SanitizeHtmlPipe } from '../../../../shared/pipes/sanitize-html.pipe';
import { ProductOverviewUtility } from '../product-overview.utility';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss'],
  animations: [
    trigger('searchItemAnimation', [transition(':enter', [style({ opacity: 0 }), animate('400ms ease-out', style({ opacity: 1 }))])]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbComponent,
    FilterMenuComponent,
    TextButtonComponent,
    AsyncPipe,
    FormsModule,
    IconButtonComponent,
    InfiniteScrollDirective,
    ProductCardComponent,
    SanitizeHtmlPipe,
    RouterLink,
  ],
})
export class ProductOverviewComponent extends ProductOverviewUtility implements OnInit, AfterViewChecked, AfterContentInit, OnDestroy {
  private deviceService = inject(DeviceDetectorService);

  allProductsCategoryCard: string;
  isDiningSix: boolean;
  isMobile: boolean;

  constructor() {
    super();

    this.isMobile = this.deviceService.isMobile();
    this.isDiningSix = this.contentService.getMerchant().type === StoreType.DININGSIX;
    this.allProductsCategoryCard = this.content.get('allProductsCategoryCardText') || this.filterMenu.allProducts;
  }
}
